// Reusable Input component
import { InputHTMLAttributes, forwardRef } from 'react';
import { cn } from '@utils/classNames';

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  error?: string;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, error, ...props }, ref) => {
    return (
      <div className="w-full">
        <input
          ref={ref}
          className={cn(
            'w-full h-[45px] sm:h-[45px] min-h-[44px] px-4 sm:px-5 rounded-[15px] bg-[#ffffff8a]',
            'font-codec font-bold text-base sm:text-base text-[#3a3a3a]',
            'placeholder:text-[#3a3a3a] placeholder:opacity-80',
            'focus:outline-none focus:ring-2 focus:ring-primary',
            'transition-all touch-manipulation',
            error && 'ring-2 ring-danger',
            className
          )}
          {...props}
        />
        {error && (
          <p className="mt-1.5 sm:mt-2 text-xs sm:text-sm text-danger font-inter break-words">{error}</p>
        )}
      </div>
    );
  }
);

Input.displayName = 'Input';













